import React from "react";
import { Link } from "react-router-dom";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[var(--color-cream)]" data-testid="error-boundary">
          <div className="text-center max-w-md mx-auto px-4">
            <div className="w-16 h-16 rounded-full mx-auto mb-6 flex items-center justify-center" style={{ backgroundColor: "rgba(231,76,60,0.1)" }}>
              <span className="text-2xl" style={{ color: "var(--color-error)" }}>!</span>
            </div>
            <h1 className="font-heading text-4xl uppercase tracking-tight text-[var(--color-text-dark)] mb-3">
              Something went wrong
            </h1>
            <p className="font-body text-[var(--color-text-mid)] mb-8">
              We're already looking into it. Please try refreshing the page.
            </p>
            <Link
              to="/"
              onClick={() => this.setState({ hasError: false })}
              className="inline-block font-heading tracking-widest uppercase px-8 py-3 rounded-[8px]"
              style={{ backgroundColor: "var(--color-gold)", color: "var(--color-navy)" }}
              data-testid="error-home-btn"
            >
              Back to Home
            </Link>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
